"use client";

import { BREAKPOINTS, type BreakpointName } from "@/constants/breakpoints";
import { useEffect, useLayoutEffect, useState } from "react";

export function useIsBelowBreakpoint(breakpoint: BreakpointName) {
  const px = BREAKPOINTS[breakpoint];
  const [isBelow, setIsBelow] = useState(false);

  useLayoutEffect(() => {
    setIsBelow(window.innerWidth < px);
  }, [px]);

  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${px - 1}px)`);
    setIsBelow(mql.matches);

    const onChange = (e: MediaQueryListEvent) => setIsBelow(e.matches);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [px]);

  return isBelow;
}

export function useIsMobile() {
  return useIsBelowBreakpoint("sm");
}

export function useIsDesktop() {
  return !useIsBelowBreakpoint("lg");
}
